import Rx from "rxjs/Rx";

// TileList export events
const mouseLeftTileContainerSource = new Rx.Subject();
const mouseEnteredTileSource = new Rx.Subject();
const tileListReloadedSource = new Rx.Subject();
const carouselInitializationRequestedSource = new Rx.Subject();
const searchRequestedSource = new Rx.Subject();

export const mouseLeftTileContainer$ = mouseLeftTileContainerSource.asObservable();
export const mouseEnteredTile$ = mouseEnteredTileSource.asObservable();
export const tileListReloaded$ = tileListReloadedSource.asObservable();
export const carouselInitializationRequested$ = carouselInitializationRequestedSource.asObservable();
export const searchRequested$ = searchRequestedSource.asObservable();

export const fireMouseLeftTileContainer = () => mouseLeftTileContainerSource.next();
export const fireMouseEnteredTile = (id) => {
    mouseEnteredTileSource.next(id);
};
export const fireTileListReloaded = () => tileListReloadedSource.next();
export const firecarouselInitializationRequested = (carousel) => {
    carouselInitializationRequestedSource.next(carousel);
};
export const fireSearchRequested = () => {
    searchRequestedSource.next();
};
//

// SearchPanel export events

const searchEventSource = new Rx.Subject();

export const newSearchDone$ = searchEventSource.asObservable();

export const fireNewSearchDone = (result) => {
    searchEventSource.next(result);
};

//

// ErrorService export events

const searchErrorsRequestedSource = new Rx.Subject();
let searchErrorsRequestedQueue = 0;

export const searchErrorsRequested$ = searchErrorsRequestedSource.asObservable();

export const fireSearchErrorsRequested = () => {
    searchErrorsRequestedSource.next();
    searchErrorsRequestedQueue++;
};

export const checkSearchErrorsRequestedQueue = () => {
    const val = searchErrorsRequestedQueue;
    if (searchErrorsRequestedQueue) {
        searchErrorsRequestedQueue--;
    }
    return val > 0;
};
